import { Component, Input, Output, EventEmitter, inject, OnInit } from "@angular/core";
import { MoiModel } from "@models/moi/MoiModel";
import { MoiPermissionModel } from "@models/moi/MoiPermissionModel";
import { ControlLinkModel } from "@models/controls/ControlLinkModel";
import { ControlDataService } from "@app/controls/services/control.data.service";
import { ModuleType } from "@enums/ModuleType";
import { nameof } from "@methods/jeffs-toolkit";
import { SearchKeyword } from "@models/workspace/SearchKeyword";
import { ComparisonType } from "@enums/workspace/ComparisonType";
import { provideTranslationScope, TranslatePipe } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/moi/i18n/scope";
import { ControlLinkableComponent } from "@app/controls/linkable/control-linkable.component";

@Component({
    selector: "moi-controls",
    templateUrl: "./moi-controls.component.html",
    styleUrls: ["./moi-controls.component.scss"],
    imports: [TranslatePipe, ControlLinkableComponent],
    viewProviders: [provideTranslationScope(scope)],
})
export class MoiControlsComponent implements OnInit {
    private _controlDataService = inject(ControlDataService);

    @Input() model: MoiModel;
    @Input() disabled = false;
    @Input() moiPermissions: MoiPermissionModel;

    moduleType = ModuleType.BIM;

    activeFilters: SearchKeyword[] = [];

    @Output() changed = new EventEmitter<number[]>();

    isLoading = true;
    lastOrganizationId = 0;
    linked: ControlLinkModel[];
    unlinked: ControlLinkModel[];

    ngOnInit(): void {
        const defaultOrganizationFilter = <SearchKeyword>{
            col: nameof<ControlLinkModel>((x) => x.organizationId),
            searchValue: this.model.OrganizationResponsible + "",
            specific: true,
            compareType: ComparisonType["Is equal to"],
        };

        this.activeFilters.push(defaultOrganizationFilter);
    }

    load() {
        if (
            !this.model ||
            !this.model.OrganizationResponsible ||
            this.lastOrganizationId === this.model.OrganizationResponsible
        ) {
            return;
        }

        this.isLoading = true;
        this.lastOrganizationId = this.model.OrganizationResponsible;

        this._controlDataService
            .getLinkableControls(ModuleType.IM, this.model.Id, this.model.OrganizationResponsible)
            .subscribe((value) => {
                this.loadData(this.model.LinkedControls, value.sortBy("name", true));
                this.isLoading = false;
            });
    }

    loadByOrganizationId(organization: number) {
        this.isLoading = true;
        this.lastOrganizationId = organization;
        this._controlDataService
            .getLinkableControls(ModuleType.IM, this.model.Id, this.model.OrganizationResponsible)
            .subscribe((value) => {
                this.loadData(this.model.LinkedControls, value.sortBy("name", true));
                this.isLoading = false;
            });
    }

    linkedChanged(linked: ControlLinkModel[]) {
        this.model.LinkedControls = linked.map((x) => x.id);
        this.changed.emit(this.model.LinkedControls);
    }

    private loadData(linkedIds: number[], items: ControlLinkModel[]) {
        const linked = [],
            unlinked = [];
        for (const item of items) {
            if (linkedIds.indexOf(item.id) >= 0) {
                linked.push(item);
            } else {
                unlinked.push(item);
            }
        }

        this.linked = linked;
        this.unlinked = unlinked;
    }
}
